let mapOpts = {
  attribution: '<a href="https://www.mapbox.com/about/maps/">Terms and Feedback</a>',
  user: 'marcoquaggiotto',
  id: 'ciolpnkxx0094rcm686o9noec',
  minZoom: 5,
  maxZoom: 20,
  // detectRetina: true,
  // tileSize: 256,
  tileSize: 512,
  zoomOffset: -1,
  accessToken: 'pk.eyJ1IjoibWFyY29xdWFnZ2lvdHRvIiwiYSI6ImJpOHI0UHcifQ.X1lr7R2W9Z3GJtBEr3Tf7g'
};

module.exports = mapOpts;


/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/map/mapOpts.es6
 **/